<script lang="ts">
  import UploadFile from './file-upload/UploadFile.svelte'
  import ForbiddenZone from './forbidden-zone/ForbiddenZone.svelte'
  import Separator from './separator/Separator.svelte'
  import CameraType from './camera-type/CameraType.svelte'
  import AddPrinter from './add-printer/AddPrinter.svelte'
  import TransformControlsMode from './transform-controls-mode/TransformControlsMode.svelte'
  import Default from './default/Default.svelte'
  import Seam from './seam/Seam.svelte'
</script>

<div class="container">
  <Default />
  <TransformControlsMode />
  <Separator />
  <AddPrinter />
  <UploadFile />
  <Separator />
  <ForbiddenZone />
  <Seam />
  <Separator />
  <CameraType />
</div>

<style lang="scss">
  .container {
    background: var(--background);
    border-radius: 0.5rem;
    bottom: 1rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    left: 0;
    margin-inline: auto;
    padding: 0.5rem;
    position: absolute;
    right: 0;
    width: fit-content;

    :global(button) {
      border-radius: 0.25rem;
    }
  }
</style>
